export function isMobile(userAgent: string): boolean {
  return /mobile|android|ios/gi.test(userAgent);
}
